import ManualAttendance from "./manualAttendance";
export default ManualAttendance;